// infinite-scroll.js - Robust version with multiple detection methods

let infiniteScroll = {
    loading: false,
    nextPageUrl: null,
    productGrid: null,
    loadingIndicator: null,
    currentUrl: window.location.href,
    
    init: function() {
        console.log('Infinite scroll: Initializing...');
        this.productGrid = document.getElementById('product-grid');
        const paginationNext = document.querySelector('.pagination__next');
        
        if (!this.productGrid) {
            console.log('Infinite scroll: No product grid found');
            return false;
        }
        
        this.nextPageUrl = paginationNext ? paginationNext.getAttribute('href') : null;
        
        if (this.nextPageUrl) {
            console.log('Infinite scroll: Next page URL found:', this.nextPageUrl);
            this.createLoadingIndicator();
            return true;
        } else {
            console.log('Infinite scroll: No more pages');
            return false;
        }
    },
    
    createLoadingIndicator: function() {
        // Remove existing if any
        if (this.loadingIndicator && this.loadingIndicator.parentNode) {
            this.loadingIndicator.parentNode.removeChild(this.loadingIndicator);
        }
        
        this.loadingIndicator = document.createElement('div');
        this.loadingIndicator.className = 'infinite-scroll-loading';
        this.loadingIndicator.style.cssText = `
            text-align: center;
            padding: 30px;
            font-size: 16px;
            color: #666;
            display: none;
            width: 100%;
            grid-column: 1 / -1;
        `;
        this.loadingIndicator.innerText = 'Loading more products...';
        this.productGrid.parentNode.insertBefore(this.loadingIndicator, this.productGrid.nextSibling);
    },
    
    loadMore: async function() {
        if (this.loading || !this.nextPageUrl || !this.productGrid) return;
        
        console.log('Infinite scroll: Loading more from', this.nextPageUrl);
        this.loading = true;
        if (this.loadingIndicator) this.loadingIndicator.style.display = 'block';
        
        try {
            const response = await fetch(this.nextPageUrl);
            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            
            const newProducts = html.getElementById('product-grid');
            const newNextUrl = html.querySelector('.pagination__next');
            
            if (newProducts && this.productGrid) {
                // Get the current product count before append
                const currentCount = this.productGrid.children.length;
                
                // Append new products
                this.productGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
                
                // Update next page URL
                this.nextPageUrl = newNextUrl ? newNextUrl.getAttribute('href') : null;
                
                console.log(`Infinite scroll: Added ${this.productGrid.children.length - currentCount} products`);
                
                if (!this.nextPageUrl) {
                    console.log('Infinite scroll: No more pages');
                    if (this.loadingIndicator) {
                        this.loadingIndicator.innerText = 'No more products';
                        setTimeout(() => {
                            if (this.loadingIndicator) this.loadingIndicator.style.display = 'none';
                        }, 2000);
                    }
                }
                
                // Dispatch event for other scripts
                document.dispatchEvent(new CustomEvent('infinite-scroll-loaded'));
            }
        } catch (error) {
            console.error('Infinite scroll error:', error);
            if (this.loadingIndicator) {
                this.loadingIndicator.innerText = 'Error loading products';
            }
        } finally {
            this.loading = false;
            if (this.loadingIndicator && this.nextPageUrl) {
                this.loadingIndicator.style.display = 'none';
            }
        }
    },
    
    checkScroll: function() {
        if (!this.productGrid || this.loading || !this.nextPageUrl) return;
        
        const scrollPosition = window.scrollY + window.innerHeight;
        const threshold = document.documentElement.scrollHeight - 800;
        
        if (scrollPosition >= threshold) {
            this.loadMore();
        }
    },
    
    reinit: function() {
        console.log('Infinite scroll: Reinitializing due to page change');
        console.log('Old URL:', this.currentUrl, 'New URL:', window.location.href);
        this.currentUrl = window.location.href;
        
        // Small delay to let DOM update
        setTimeout(() => {
            if (this.init()) {
                console.log('Infinite scroll: Successfully reinitialized');
            } else {
                console.log('Infinite scroll: No pagination on this page');
            }
        }, 300);
    },
    
    destroy: function() {
        // Clean up event listeners if needed
        this.loading = false;
        this.nextPageUrl = null;
        if (this.loadingIndicator && this.loadingIndicator.parentNode) {
            this.loadingIndicator.parentNode.removeChild(this.loadingIndicator);
        }
    }
};

// Initialize on page load
setTimeout(() => infiniteScroll.init(), 200);

// SCROLL EVENT with throttle
let ticking = false;
window.addEventListener('scroll', function() {
    if (!ticking) {
        window.requestAnimationFrame(function() {
            infiniteScroll.checkScroll();
            ticking = false;
        });
        ticking = true;
    }
});

// RESIZE EVENT
window.addEventListener('resize', function() {
    infiniteScroll.checkScroll();
});

// METHOD 1: Listen for Shopify facet updates
document.addEventListener('facets-updated', function() {
    console.log('Event detected: facets-updated');
    infiniteScroll.reinit();
});

// METHOD 2: Listen for Shopify's AJAX events
document.addEventListener('ajaxSuccess', function(event) {
    if (event.detail && event.detail.url && event.detail.url.includes('/collections/')) {
        console.log('Event detected: ajaxSuccess for collection');
        infiniteScroll.reinit();
    }
});

// METHOD 3: Watch for URL changes (most reliable)
let lastUrl = window.location.href;
new MutationObserver(function() {
    const url = window.location.href;
    if (url !== lastUrl) {
        console.log('URL changed from', lastUrl, 'to', url);
        lastUrl = url;
        infiniteScroll.reinit();
    }
}).observe(document, { subtree: true, childList: true });

// METHOD 4: Listen for history changes
window.addEventListener('popstate', function() {
    console.log('Event detected: popstate');
    infiniteScroll.reinit();
});

// METHOD 5: Watch for changes to the product grid container
const productGridContainer = document.getElementById('ProductGridContainer');
if (productGridContainer) {
    new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Check if new nodes contain a product grid
                const hasNewProductGrid = Array.from(mutation.addedNodes).some(node => 
                    node.nodeType === 1 && (node.id === 'product-grid' || node.querySelector && node.querySelector('#product-grid'))
                );
                if (hasNewProductGrid) {
                    console.log('Product grid container updated');
                    infiniteScroll.reinit();
                }
            }
        });
    }).observe(productGridContainer, { childList: true, subtree: true });
}

console.log('Infinite scroll: Loaded with multiple detection methods');